<template>
  <p v-if="label">{{ label }}</p>
  <v-row no-gutters>
    <v-col cols="12" md="4">
      <PAutocomplete
        :items="itemsStore.dialCodes"
        :select-text="phoneDialCode"
        :clearable="false"
        :disabled="disabled"
        @field-updated="(val: string) => newDialCode(val)"
      />
    </v-col>
    <v-col cols="12" md="8">
      <PInputField
        :value="phoneNumber"
        :readonly="disabled"
        @update-event="(val: string) => { (phoneNumber = val); emitInputValue() }"
      />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { ref } from "vue";
import PAutocomplete from "./PAutocomplete.vue";
import PInputField from "./PInputField.vue";
import { useItemsStore } from "@/stores/itemsStore";

const props = withDefaults(
  defineProps<{
    value?: string;
    label?: string;
    disabled?: boolean;
  }>(),
  {
    label: "",
    disabled: false,
  }
);

const emit = defineEmits<{
  (e: "updateEvent", newInput: string): void;
}>();

const itemsStore = useItemsStore();

const phoneDialCode = ref(getDialCode(props.value)); // defaults to Norway
const phoneNumber = ref(getPhoneNr(props.value));

function getDialCode(phoneNr: string | undefined): string {
  return phoneNr?.split(" ")[0] ?? "(+47)";
}

function getPhoneNr(phoneNr: string | undefined): string {
  if (!phoneNr) {
    return "";
  }

  const parts = phoneNr.split(" ");

  if (parts.length <= 1) return "";

  return phoneNr.substring(phoneNr.indexOf(" ") + 1);
}

function newDialCode(dialCode: string) {
  phoneDialCode.value = dialCode + " ";
  emitInputValue();
}

function emitInputValue(): void {
  emit("updateEvent", phoneDialCode.value + phoneNumber.value);
}
</script>
